import { MutationHookOptions, useMutation } from "@apollo/client";
import addProductsToCartGql from "@whoppah/apollo/mutation/addProductsToCart.graphql";
import {
  AddProductsToCartMutation,
  AddProductsToCartMutationVariables,
} from "@whoppah/apollo/schema";

const useAddProductsToCart = (
  options?: MutationHookOptions<
    AddProductsToCartMutation,
    AddProductsToCartMutationVariables
  >
) => {
  return useMutation(addProductsToCartGql, options);
};

export default useAddProductsToCart;
